export const isProd = false;

export const CONFIG = {
  siteName: "Anthony V. Lombardo",
  siteRoot: "https://anthonyvlombardo.com",
  prodPath: "/web-dev",
  blog: !isProd,
  sitePaths: {
    blog: "/blog",
    privacy: "/privacy-policy",
    resources: "/resources",
    contact: "/contact",
  },
  projectBasePath: "img/portfolio/",
  social: {
    github: "https://github.com/anthonyv1121",
    facebook: "https://www.facebook.com/anthony.lombardo.545",
    linkedIn: "https://www.linkedin.com/in/anthony-lombardo-45b48a15/",
    twitter: "https://twitter.com/avl_creative",
  },
};
export const needsTargetAttribute = (url) =>
  url.indexOf(CONFIG.siteRoot) === -1 ||
  url.indexOf(CONFIG.siteRoot + "/dev") !== -1
    ? {
        target: "blank",
      }
    : null;
